import React, { useState } from "react";
import { auth, db, functions } from "../firebase";
import { signInWithEmailAndPassword, createUserWithEmailAndPassword, sendPasswordResetEmail } from "firebase/auth";
import { doc, setDoc, serverTimestamp } from "firebase/firestore";
import { httpsCallable } from "firebase/functions";

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [phone, setPhone] = useState("");
  const [fullName, setFullName] = useState("");
  const [isRegister, setIsRegister] = useState(false);
  const [isForgot, setIsForgot] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [loading, setLoading] = useState(false);

  const handle = async () => {
    setError(""); setSuccess(""); setLoading(true);
    try {
      if (isForgot) {
        await sendPasswordResetEmail(auth, email);
        setSuccess("Password reset email sent! Check your inbox.");
        setIsForgot(false);
      } else if (isRegister) {
        if (!fullName) { setError("Please enter your full name"); setLoading(false); return; }
        if (!phone) { setError("Please enter your phone number"); setLoading(false); return; }
        const userCred = await createUserWithEmailAndPassword(auth, email, password);
        await setDoc(doc(db, "users", userCred.user.uid), {
          email, fullName, phone,
          createdAt: serverTimestamp(),
          kycStatus: "pending",
        }, { merge: true });
        await setDoc(doc(db, "wallets", userCred.user.uid), {
          balance: 0, totalDeposited: 0, totalWithdrawn: 0, pnl: 0,
          updatedAt: serverTimestamp(),
        }, { merge: true });
      } else {
        await signInWithEmailAndPassword(auth, email, password);
      }
    } catch (e) {
      setError(e.message.replace("Firebase: ", "").replace(/\(auth.*\)/, ""));
    }
    setLoading(false);
  };

  return (
    <div className="login-wrap">
      <div className="login-box">
        <div className="login-logo">TROY TRADE</div>
        <div className="login-sub">Investment Platform by PT. Artemis Bosphora Arthagena</div>

        {!isForgot ? (
          <>
            {isRegister && (
              <>
                <input className="inp" placeholder="Full Name" value={fullName} onChange={e => setFullName(e.target.value)} />
                <input className="inp" placeholder="Phone Number (e.g. +62812345678)" value={phone} onChange={e => setPhone(e.target.value)} />
              </>
            )}
            <input className="inp" placeholder="Email" value={email} onChange={e => setEmail(e.target.value)} />
            <input className="inp" placeholder="Password" type="password" value={password} onChange={e => setPassword(e.target.value)} onKeyDown={e => e.key === "Enter" && handle()} />
            {error && <div className="err">{error}</div>}
            {success && <div style={{color:"#00C896", fontSize:"12px", textAlign:"center"}}>{success}</div>}
            <button className="btn-main" onClick={handle} disabled={loading}>
              {loading ? "Please wait..." : isRegister ? "Create Account" : "Login"}
            </button>
            <div className="toggle" onClick={() => { setIsRegister(!isRegister); setError(""); setSuccess(""); }}>
              {isRegister ? "Already have account? Login" : "No account? Register"}
            </div>
            <div className="toggle" style={{color:"#F0A500"}} onClick={() => { setIsForgot(true); setError(""); }}>
              Forgot password?
            </div>
          </>
        ) : (
          <>
            <div style={{fontSize:"13px", color:"#8A94B0", textAlign:"center"}}>
              Enter your email to receive a password reset link.
            </div>
            <input className="inp" placeholder="Email" value={email} onChange={e => setEmail(e.target.value)} />
            {error && <div className="err">{error}</div>}
            {success && <div style={{color:"#00C896", fontSize:"12px", textAlign:"center"}}>{success}</div>}
            <button className="btn-main" onClick={handle} disabled={loading}>
              {loading ? "Sending..." : "Send Reset Email"}
            </button>
            <div className="toggle" onClick={() => { setIsForgot(false); setError(""); }}>
              ← Back to Login
            </div>
          </>
        )}

        <div className="login-risk">
          <div className="login-risk-title">⚠️ Risk Warning</div>
          <p>Trading leveraged products such as Forex and CFDs carries a high level of risk and may not be suitable for all investors. You may lose more than your initial investment. PT. Artemis Bosphora Arthagena does not provide financial advice. All services are provided on an execution-only basis.</p>
          <p style={{marginTop:"6px"}}>Reg. No. 8426105-4 | License HE433420 | Seychelles</p>
        </div>
      </div>
    </div>
  );
}